export function clearPersistedSessionStorage(): void {
  try {
    localStorage.removeItem("persist:root");
  } catch {
    // ignore storage errors during logout
  }
}
